import { combineReducers } from 'redux';

import { offer } from './offer/offer';

const selected = combineReducers({
  offer,
});

export { selected };
